<template>
    <v-tabs
                :key="plans.length"
                v-model="activePlan"
                height="44"
                centered
                style="max-width: Calc(100vw - 90px);"
                color="transparent"
                dark
                slider-color="transparent"
                show-arrows="false"
            >
                <v-tab v-for="(plan, i) in plans" :key="i" ripple style="text-transform: none;">
                    {{ $t('plan_calculator.plan_number', {n: String.fromCharCode(97 + i).toUpperCase() }) }} <v-icon v-if="plans.length > 1 && i === activePlan" style="margin-left: 8px; font-size: 13px;" @click.stop="deletePlan(i)" v-text="'close'" />
                </v-tab>
            </v-tabs>


</template>
<script>
    export default {
        props: {
            plans: {
                type: Object,
            },
            activePlan: {
                type: Number,
            }
        }
    }
</script>
